import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function UrgencyBar() {
  return <div className="bg-orange-600 text-white py-2 px-4 text-center font-bold text-xs md:text-sm tracking-wider uppercase flex items-center justify-center gap-2" data-id="element-142">
      <AlertTriangle className="w-4 h-4 fill-white text-orange-600" data-id="element-143" />
      <span data-id="element-144">Fast-Track Protocol: 68% OFF For New Adopters</span>
      <AlertTriangle className="w-4 h-4 fill-white text-orange-600" data-id="element-145" />
    </div>;
}